export default __webpack_public_path__ + "static/media/non-interface-apis.aeaa4c9a.svg";